import { Component, OnInit, inject } from '@angular/core';
import { Background } from '../../shared/components/background/background';
import { Connect } from '../../shared/components/connect/connect';
import { HeroSection } from '../../shared/components/hero-section/hero-section';
import { Projects } from './component/projects/projects';
import { InfoCard } from '../../shared/components/info-card/info-card';
import { Button } from '../../shared/components/button/button';
import { CalendlyService } from '../../shared/services/calendly.service';
import { SeoService } from '../../shared/services/seo.service';

@Component({
  selector: 'app-case-studies',
  imports: [Background, HeroSection, Connect, Projects, InfoCard, Button],
  templateUrl: './case-studies.html',
  styleUrl: './case-studies.scss'
})
export class CaseStudies implements OnInit {
  protected file = 'marketing-case-studies';
  /** Left/editorial hero heading — "marketing" + "studies" in the brand gradient, "case" in white. */
  protected heroTitleHtml = '<span class="gradient-text">marketing</span><br>case<br><span class="gradient-text">studies</span>';

  private calendly = inject(CalendlyService);
  private seo = inject(SeoService);

  scheduleCall() {
    this.calendly.openPopup().catch(() => { });
  }

  ngOnInit() {
    this.seo.apply({
      title: 'Marketing Case Studies',
      description: 'Explore SEM Nexus marketing case studies demonstrating ASO, paid UA, influencer performance, and ROI gains across key app categories.',
      canonical: '/marketing-case-studies/',
      image: 'https://semnexus.com/images/marketing-case-studies/backgrounds/marketing-case-studies.avif',
      imageAlt: 'SEM Nexus app marketing case studies',
      type: 'website',
    });
    this.seo.setBreadcrumbs([
      { name: 'Home', url: '/' },
      { name: 'Marketing Case Studies' },
    ]);
  }
}
